var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "resultsWrapper" },
    [
      _c(
        "div",
        {
          ref: "resultsWrapperInner",
          class: ["dc-post-grid-results-inner", _vm.results[0].post_type],
          attrs: { "aria-live": "polite" }
        },
        [
          _vm.results.length === 0
            ? _c("p", [_vm._v(_vm._s(_vm.dctxt("No posts found...")))])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.results, function(result, index) {
            return _c(
              "div",
              { key: "result-" + index, staticClass: "item" },
              [
                _vm.results[0].post_type == "dc_person"
                  ? _c("PersonCard", {
                      attrs: {
                        id: result.id,
                        title: result.title,
                        excerpt: result.excerpt,
                        url: result.url,
                        image: result.image,
                        label: result.label,
                        position: result.position,
                        phone: result.phone,
                        email: result.email,
                        bio: result.bio
                      }
                    })
                  : ["dc_course", "page"].includes(_vm.results[0].post_type)
                  ? _c("CourseCard", {
                      attrs: {
                        id: result.id,
                        title: result.title,
                        excerpt: result.excerpt,
                        url: result.url,
                        image: result.image,
                        label: result.label
                      }
                    })
                  : _c("NansenCard", {
                      attrs: {
                        id: result.id,
                        title: result.title,
                        excerpt: result.excerpt,
                        url: result.url,
                        image: result.image,
                        label: result.label,
                        terms: result.terms
                      }
                    })
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.showLoadMore &&
      !_vm.endOfResults &&
      typeof _vm.totalPages === "undefined"
        ? _c("LoadMore", {
            attrs: { loading: _vm.loading, searchButtonId: _vm.searchButtonId },
            on: {
              click: function($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.loadMore.apply(null, arguments)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }